import clsx from "clsx";
import { GatsbyImage } from "gatsby-plugin-image";
import React, { FC } from "react";

import { useProductsComparator } from "../../../../contexts/products-comparator";
import { Icon } from "../../../icon";

export interface ProductComparatorCardProps {
  product: Queries.ProductDataFragment | null;
  labels: {
    "product-comparator-card-empty-state": string;
  };
}

export const ProductComparatorCard: FC<ProductComparatorCardProps> = ({ product, labels }) => {
  const { toggleProduct } = useProductsComparator();
  const image = product?.cardImages?.[0]?.gatsbyImageData ?? null;
  return (
    <div
      className={clsx(
        "border-2 border-primary-light rounded-xl overflow-hidden flex-1 relative",
        !product && "border-opacity-70 bg-opacity-70 bg-neutral"
      )}
    >
      {product ? (
        <div className="w-full h-full">
          <div className="flex flex-col lg:flex-row items-center w-full h-full">
            {image && (
              <GatsbyImage
                image={image}
                alt={product.name ?? ""}
                className="aspect-square w-full lg:flex-1 lg:h-full"
                objectFit="cover"
              />
            )}
            <div
              className={clsx(
                "flex-1 font-bold p-4 pt-6 h-full",
                "break-words hyphens-auto text-sm md:text-base"
              )}
            >
              {product.name}
            </div>
          </div>
          <button
            type="button"
            className="absolute right-2 lg:right-1 top-2 lg:top-1"
            onClick={() => toggleProduct(product)}
          >
            <Icon
              icon="close"
              className="w-6 md:w-7 lg:w-5 h-6 md:h-7 lg:h-5 bg-light bg-opacity-50 rounded-full"
            />
          </button>
        </div>
      ) : (
        <div className="w-full h-full text-xs sm:text-sm p-4 flex items-center font-light">
          {labels["product-comparator-card-empty-state"]}
        </div>
      )}
    </div>
  );
};
